<palantir-card
  [attr.activatable]="activatable"
  (click)="activatable ? onAttachmentClick(attachment.id) : null"
>
  <palantir-card-thumbnail>
    @if (isImage(extension)) {
      <ng-container>
        @if (fileUrl) {
          <img [src]="fileUrl" [alt]="attachment.title" />
        }
        @if (!fileUrl) {
          <palantir-avatar size="xs">
            <palantir-icon name="picture" />
          </palantir-avatar>
        }
      </ng-container>
    }

    @if (isVideo(extension)) {
      <ng-container>
        @if (fileUrl) {
          <div>
            <img
              [src]="fileUrl"
              [alt]="attachment.title"
              style="display: block; width: 100%; height: auto"
            />
            <span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
              <palantir-icon name="play-outline" class="palantir-attachment-card__content--video" />
            </span>
          </div>
        }
        @if (!fileUrl) {
          <palantir-avatar size="xs">
            <palantir-icon
              name="video-file-outline"
              class="palantir-attachment-card__content--default"
            />
          </palantir-avatar>
        }
      </ng-container>
    }

    @if (fileUrl?.includes('base64')) {
      <ng-container>
        @if (fileUrl) {
          <img [src]="fileUrl" [alt]="attachment.title" />
        }
        @if (!fileUrl) {
          <palantir-avatar size="xs">
            <palantir-icon name="picture" />
          </palantir-avatar>
        }
      </ng-container>
    }

    @if (isPdf) {
      <palantir-avatar size="xs">
        <palantir-icon name="pdf" class="palantir-attachment-card__content--pdf" />
      </palantir-avatar>
    }

    @if (isWord) {
      <palantir-avatar size="xs">
        <palantir-icon name="doc" class="palantir-attachment-card__content--doc" />
      </palantir-avatar>
    }

    @if (isExcel) {
      <palantir-avatar size="xs">
        <palantir-icon name="excel" class="palantir-attachment-card__content--excel" />
      </palantir-avatar>
    }

    @if (isPresentation) {
      <palantir-avatar size="xs">
        <palantir-icon name="slide" class="palantir-attachment-card__content--slide" />
      </palantir-avatar>
    }

    @if (isCsv) {
      <palantir-avatar size="xs">
        <palantir-icon name="csv" class="palantir-attachment-card__content--csv" />
      </palantir-avatar>
    }

    @if (isText) {
      <palantir-avatar size="xs">
        <palantir-icon name="txt" class="palantir-attachment-card__content--txt" />
      </palantir-avatar>
    }

    @if (isDefault) {
      <palantir-avatar size="xs">
        <palantir-icon
          name="image-file-outline"
          class="palantir-attachment-card__content--default"
        />
      </palantir-avatar>
    }

    @if (isArchive) {
      <palantir-avatar size="xs">
        <palantir-icon name="archive-outline" class="palantir-attachment-card__content--archive" />
      </palantir-avatar>
    }

    @if (isAudio) {
      <palantir-avatar size="xs">
        <palantir-icon name="audio-file-outline" class="palantir-attachment-card__content--audio" />
      </palantir-avatar>
    }

    @if (isCad) {
      <palantir-avatar size="xs">
        <palantir-icon name="design-outline" class="palantir-attachment-card__content--cad" />
      </palantir-avatar>
    }

    @if (loading) {
      <palantir-progress-bar [progress]="loading.progress" [mode]="loading.mode" />
    }
  </palantir-card-thumbnail>

  <palantir-card-content class="palantir-attachment-card__info__content">
    <ng-content select="palantir-attachment-card-content" />
  </palantir-card-content>
</palantir-card>

<div class="palantir-attachment-card__button-container">
  <ng-content select="palantir-attachment-card-buttons" />
</div>
